import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

export interface FeeBreakdownData {
  type: 'myOrder' | 'studioOrder';
  // myOrder fields
  subTotal?: number;
  discount?: number;
  platformFee?: number;
  total?: number;
  // studioOrder fields
  revenue?: number;
  commission?: number;
  gatewayFee?: number;
  gst?: number;
  platformFeeTotal?: number;
  earnings?: number;
}

@Component({
  selector: 'ipm-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss']
})
export class InfoIconComponent {
  @Input() message: string = '';
  @Input() title: string = 'Information';
  @Input() iconSize: string = '16px';
  @Input() iconColor: string = '#666';
  @Input() isTooltip: boolean = false;
  @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() showButton: boolean = true ; 
  @Input() feeBreakdown: FeeBreakdownData | null = null;

  @ViewChild('infoPopupTemplate', { static: true }) infoPopupTemplate: TemplateRef<any>;

  constructor(public commonService: CommonService) {}

  openPopup() {
    if (this.isTooltip) {
      return; // Don't open popup if tooltip mode is enabled
    }
    
    const sendData: any = {
      message: this.message,
      title: this.title,
      feeBreakdown: this.feeBreakdown
    };
    
    const className = this.commonService.getClassName('ipm-info-popup-model');
    this.commonService.openModel(
      this.infoPopupTemplate,
      sendData,
      className,
      false
    );
  }

  closeDialog() {
    this.commonService.closingPopupWithSendData('close');
  }
}
